var addTask, callTask, channel, id, tasks;

if (typeof MessageChannel !== "undefined" && MessageChannel !== null) {
  channel = new MessageChannel();
  tasks = {};
  id = 0;
  addTask = function(cb) {
    tasks[++id] = cb;
    return id;
  };
  callTask = function(i) {
    tasks[i]();
    return delete tasks[i];
  };
  channel.port1.onmessage = function(arg) {
    var data;
    data = arg.data;
    return callTask(data);
  };
  module.exports = function(cb) {
    return channel.port2.postMessage(addTask(cb.bind(this)));
  };
} else {
  module.exports = function(cb) {
    return setTimeout(cb.bind(this), 0);
  };
}



//////////////////
// WEBPACK FOOTER
// /home/peaul/ceri/ceri/lib/_nextTick.js
// module id = 38
// module chunks = 1